import { UploadEnum } from "@/TS/Enums/global_enums";

export const MAX_FILE_SIZE = UploadEnum.MAX_FILE_SIZE; // 4MB
export const MAX_FILE_SIZE_LABEL = UploadEnum.MAX_FILE_SIZE_LABEL; // 4MB
export const MAX_FILE_SIZE_ERROR = UploadEnum.MAX_FILE_SIZE_ERROR; // La taille du fichier est trop grande
